export const BASE_URL = process.env.REACT_APP_BASE_API_URL;

/**
 * Endpoints organized to align with Swagger
 */

// Admin endpoints
export const getApiVersionUrl = `${BASE_URL}/admin/apiVersion`;
export const usersUrl = `${BASE_URL}/admin/listUsers`;
export const getUserRolesUrl = `${BASE_URL}/admin/roleNames`;
export const revokeUserAccessUrl = `${BASE_URL}/admin/user/clear`;
export const dischargeUrl = `${BASE_URL}/admin/dischargePatients`;
export const encountersUrl = `${BASE_URL}/encounters`;
export const empDepartmentsUrl = `${BASE_URL}/admin/dept/getByFacility`;

// Config endpoints
export const divisionsUrl = `${BASE_URL}/division`;
export const facilitiesUrl = `${BASE_URL}/facility`;
export const unitsUrl = `${BASE_URL}/unit`;
export const unitsConfigUrl = `${BASE_URL}/unit/config`;

// Discussion endpoints
export const discussionUrl = `${BASE_URL}/discussions`;

// Employee endpoints
export const addEmployeeNoteUrl = `${BASE_URL}/employee/profileNote/add`;
export const removeEmployeeNoteUrl = `${BASE_URL}/employee/profileNote/remove`;
export const employeeSearchUrl = `${BASE_URL}/employee/search`;
export const employeeNotesUrl = `${BASE_URL}/employee/notes`;
export const employeeShiftStatusUrl = `${BASE_URL}/employee/shiftStatusList`;

// Patient endpoints
export const addPatientNoteUrl = `${BASE_URL}/patient/profileNote/add`;
export const removePatientNoteUrl = `${BASE_URL}/patient/profileNote/remove`;

// Report endpoints
export const patientHistorySearchUrl = `${BASE_URL}/report/patientHistory`;
export const patientRoundHistoryUrl = `${BASE_URL}/report/patientRoundHistory`;
export const employeeRoundHistoryUrl = `${BASE_URL}/report/employeeRoundHistory`;
export const getComplianceReportUrl = `${BASE_URL}/report/complianceReport`;
export const getEmpComplianceReportUrl = `${BASE_URL}/report/empComplianceReport`;
export const getPatientRoundsUrl = `${BASE_URL}/report/rounds/patient`;
export const getPatientRoundsReportUrl = `${BASE_URL}/report/exportRounds`;
export const getEmployeeRoundsUrl = `${BASE_URL}/report/rounds/employee`;
export const getEmployeeFreqUrl = `${BASE_URL}/report/rounds/employee/frequency`;
export const getEmployeeRoundsReportUrl = `${BASE_URL}/report/exportEmpRounds`;
export const feedbackByFacilityUrl = `${BASE_URL}/report/feedback`;
export const issuesByFacilityUrl = `${BASE_URL}/report/issue`;
export const getCensusReportUrl = `${BASE_URL}/report/census`;

// Round endpoints
export const postRoundUrl = `${BASE_URL}/round`;
export const getRoundUrl = `${BASE_URL}/round`; // Possible duplicate
export const getRoundsListUrl = `${BASE_URL}/roundsList`;

// Sas Endpoints
export const sasTokenUrl = `${BASE_URL}/sas/pictures`;

// Stoplight endpoints
export const baseStoplightUrl = `${BASE_URL}/stoplights`;
export const getStoplightsByLocationUrl = `${BASE_URL}/stoplights/GetByLocation`;
export const searchStoplightsUrl = `${BASE_URL}/stoplights/search`;

// Task endpoints
export const tasksByIdUrl = `${BASE_URL}/task`;
export const postNewTaskUrl = `${BASE_URL}/task`; // Possible duplicate
export const updateTaskUrl = `${BASE_URL}/tasks`;
export const ticketDetailsUrl = `${BASE_URL}/task/ticket`;
export const getPatientIssuesUrl = `${BASE_URL}/task/getIssueByUnitId`;
export const getTasksByAccountNumberUrl = `${BASE_URL}/task/accountNumber`;
export const getTasksByEmployeeIdUrl = `${BASE_URL}/task/employeeId`;
export const verifyControlNumberUrl = `${BASE_URL}/task/getGEBiomedControlNumber`;
export const getECLocationsNewUrl = `${BASE_URL}/task/getECLocationsNew`;
export const getGELocationsUrl = `${BASE_URL}/task/getGELocations`;
export const getIssueStatusesUrl = `${BASE_URL}/task/issueStatuses`;
export const completeTaskUrl = `${BASE_URL}/task/complete`;
export const shareTaskUrl = `${BASE_URL}/task/share`;
export const deleteTaskUrl = `${BASE_URL}/task/delete`;
export const issueSearchUrl = `${BASE_URL}/task/issueSearch`;
export const getFeedbackByUnitsIdsUrl = `${BASE_URL}/task/getFeedbackByUnitId`;
export const getEmployeeIssuesUrl = `${BASE_URL}/task/getIssueByEmployeeList`;
export const getFeedbackByEmployeeListUrl = `${BASE_URL}/task/getFeedbackByEmployeeList`;
export const getCategoriesByTypeUrl = `${BASE_URL}/task/getCategoriesByType`;

// Template endpoints
export const templateMasterUrl = `${BASE_URL}/template/master`;
export const templateByIdUrl = `${BASE_URL}/template`;
export const questionBankUrl = `${BASE_URL}/template/question`;
export const templateConfigUrl = `${BASE_URL}/template/config`;
export const templateTreeUrl = `${BASE_URL}/template/treeView`;
export const getFullSurveyUrl = `${BASE_URL}/template/fullSurvey`;
export const templateDocUrl = `${BASE_URL}/template/doc`;
export const templatePublishedByLocationAndTypeUrl = `${BASE_URL}/template/isPublished`;

// User endpoints
export const userAuthUrl = `${BASE_URL}/user/auth`;
export const addEmployeeToUserUrl = `${BASE_URL}/user/employee/add`;
export const updateCurrentFacilityUrl = `${BASE_URL}/user/facility`;
export const removeEmployeeFromUserUrl = `${BASE_URL}/user/employee/remove`;
export const profilePicUrl = `${BASE_URL}/user/picture`;
export const addFavoriteUnitsUrl = `${BASE_URL}/user/units/add`;
export const removeFavoriteUnitsUrl = `${BASE_URL}/user/units/remove`;
export const addDelegateToUserUrl = `${BASE_URL}/user/employee/grant-list-access`;
export const removeDelegateFromUserUrl = `${BASE_URL}/user/employee/revoke-list-access`;
export const employeeConfigUrl = `${BASE_URL}/user/employee/config`;
export const updateRoundSubjectHiddenStatusUrl = `${BASE_URL}/user/employee/config/status`;
export const postEmployeeListConfigUrl = `${BASE_URL}/user/employee/employee-list-config
`;
export const patientsToRoundUrl = `${BASE_URL}/user/patientsToRound`;
export const employeesToRoundUrl = `${BASE_URL}/user/employeesToRound`;
export const getSupportSubjectsToRoundUrl = `${BASE_URL}/user/supportSubjectsToRound`;
export const userRoundHistoryUrl = `${BASE_URL}/user/roundHistory`;
export const userAccessUrl = `${BASE_URL}/user/access`;
export const getUserImageUrl =
  'https://orb-qa-api-centralus.azurewebsites.net/rounding-docs/api/v1/user/picture';
